import AboutSection from '../AboutUs/AboutSection';
import LegacySection from '../AboutUs/LegacySection';
import MissionVision from '../AboutUs/MissionVision';
import Milestones from '../AboutUs/Milestones';
import GrowthPillars from '../AboutUs/GrowthPillars';
import FocusAreas from '../AboutUs/FocusAreas'
import Hero from '../AboutUs/Hero'

export default function AboutUs() {
  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <main>
        {/* <Hero /> */}
        <AboutSection />
        <LegacySection />
        <MissionVision />
        <Milestones />
        <GrowthPillars />
        <FocusAreas />
      </main>

    </div>
  );
}